import { render } from "./PPS_Message.vue?vue&type=template&id=a4711ac4"
import script from "./PPS_Message.vue?vue&type=script&lang=js"
export * from "./PPS_Message.vue?vue&type=script&lang=js"

import "./PPS_Message.vue?vue&type=style&index=0&id=a4711ac4&lang=scss"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__